import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { MessageSquare, ShoppingCart, Utensils, Brain, CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const CaseStudySolution = () => {
  const { ref, isVisible } = useScrollAnimation();
  const { t, tObject } = useLanguage();
  const p = "caseStudyBgeh.solution";
  const items = tObject<Array<{ title: string; description: string; features: string[] }>>(`${p}.items`);
  const icons = [MessageSquare, ShoppingCart, Utensils, Brain];
  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className={cn("mb-12 transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <p className="text-sm font-semibold text-chathero-mint uppercase tracking-wider mb-3">{t(`${p}.badge`)}</p>
            <h2 className="text-2xl md:text-3xl font-bold text-primary mb-4">{t(`${p}.title`)}</h2>
            <p className="text-lg text-muted-foreground max-w-3xl">{t(`${p}.intro`)}</p>
          </div>
          <div className="space-y-8">
            {items.map((item, index) => { const Icon = icons[index] || MessageSquare; return (
              <div key={index} className={cn("bg-secondary/30 rounded-2xl p-6 md:p-8 border border-border transition-all duration-500", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{ transitionDelay: isVisible ? `${index * 150}ms` : "0ms" }}>
                <div className="flex flex-col md:flex-row md:items-center gap-6">
                  <div className="md:w-1/3">
                    <div className="w-14 h-14 rounded-xl bg-chathero-mint/10 flex items-center justify-center mb-4"><Icon className="w-7 h-7 text-chathero-mint" /></div>
                    <h3 className="text-xl font-bold text-primary mb-2">{item.title}</h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">{item.description}</p>
                  </div>
                  <div className="md:w-2/3 md:border-l md:border-border md:pl-6 flex items-center">
                    <div className="grid sm:grid-cols-3 gap-4">
                      {item.features.map((feature, idx) => (
                        <div key={idx} className="flex items-start gap-2"><CheckCircle2 className="w-5 h-5 text-chathero-mint flex-shrink-0 mt-0.5" /><span className="text-sm text-foreground">{feature}</span></div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ); })}
          </div>
        </div>
      </div>
    </section>
  );
};
export default CaseStudySolution;
